import { useMutation } from '@tanstack/react-query';
import { ImageAPI } from '@base/api/image-api';
import type { UploadImagesParams } from '@base/api/image-api';

const imageAPI = new ImageAPI();

export function useUploadImages() {
  return useMutation({
    mutationFn: (params: UploadImagesParams) => imageAPI.upload(params),
  });
}
